import Matter from "matter-js";

const GameManager = (entities: any, { time }: { time: any }) => {
    if (!entities || !entities.physics) return;

    let engine = entities.physics.engine;
    let flyer = entities.flyer.body;

    if (flyer.isStatic) {
        Matter.Body.setStatic(flyer, false);
    }

    Matter.Engine.update(engine, time.delta);

    return entities;
}

export default GameManager;